/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Indicateinterest_Validation_Acknowledgmentrequired3Inputs */

const en_coinvestments_indicateinterest_validation_acknowledgmentrequired3 = /** @type {(inputs: Coinvestments_Indicateinterest_Validation_Acknowledgmentrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please acknowledge that you understand this is an indicative amount`)
};

/**
* | output |
* | --- |
* | "Please acknowledge that you understand this is an indicative amount" |
*
* @param {Coinvestments_Indicateinterest_Validation_Acknowledgmentrequired3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_indicateinterest_validation_acknowledgmentrequired3 = /** @type {((inputs?: Coinvestments_Indicateinterest_Validation_Acknowledgmentrequired3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Indicateinterest_Validation_Acknowledgmentrequired3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_indicateinterest_validation_acknowledgmentrequired3(inputs)
});
export { coinvestments_indicateinterest_validation_acknowledgmentrequired3 as "coInvestments_indicateInterest_validation_acknowledgmentRequired" }